export const defaultProps = {
  easing: "cubic-bezier(0.16, 1, 0.3, 1)",
  distance: "72px",
  duration: 1200,
  desktop: true,
  mobile: true,
  viewFactor: 0.1,
  interval: 140,
  opacity: 0,
  scale: 0.96,
};

export const targetElements = [
  {
    element: ".reveal",
    animation: {
      origin: "bottom",
    },
  },
  {
    element: ".reveal-left",
    animation: {
      origin: "left",
      distance: "96px",
      duration: 1300,
      scale: 1,
    },
  },
  {
    element: ".reveal-right",
    animation: {
      origin: "right",
      distance: "96px",
      duration: 1300,
      scale: 1.03,
    },
  },
  {
    element: ".reveal-soft",
    animation: {
      origin: "bottom",
      distance: "56px",
      duration: 1400,
      scale: 1,
    },
  },
  {
    element: ".service-item.reveal",
    animation: {
      origin: "bottom",
      distance: "48px",
      interval: 160,
      scale: 1,
      duration: 1000,
    },
  },
];
